

import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/map'

import { UCuencaError } from '../../compartido/errores/UCuencaError';
import { UCuencaErrorHandler } from '../../compartido/errores/UCuencaErrorHandler';


import { MenuItem } from 'primeng/primeng';
import { TreeNode } from 'primeng/components/common/api';
import { Menu } from '../modelado/sar/menu-sar';
import { Constantes } from '../../compartido/constantes/constantes';
import { MensajesConstantes } from '../../compartido/constantes/mensajes';
import { CustomHttp } from '../../compartido/customHttp/CustomHttp';
import {map, catchError} from 'rxjs/operators'; 

class MenuItemUC implements MenuItem {
  label?: string;
  icon?: string;
  url?: string;
  routerLink?: any;
  items?: MenuItemUC[] = [];

}



@Injectable()
export class MenuService {

  private NOMBRE_SERVICIO = '/menu';

  private BASE_URL = Constantes.URL_SERVER_SAR;

  private errorHandler: UCuencaErrorHandler = new UCuencaErrorHandler();

  constructor(private _httpCustom: CustomHttp) {

  }



  /**
   * 
   * @param objMenu 
   */
  crear(objMenu: Menu): Observable<Menu> {
    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/crear';



    return this._httpCustom
      .put(url,
        JSON.stringify(objMenu),
        { headers: Constantes.HEADERS })
        .pipe(map(
          (r: Response) => {
            if (r.status === 200) {
              let objMenu2: Menu;
              if (r.json().status === 'OK') {
                objMenu2 = r.json().objeto as Menu;
                return objMenu2;
              } else {
                throw new UCuencaError('ERROR: ' + r.json().message);
              }
            } else {
              throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
            }
          }
        ),
        catchError(this.errorHandler.handleError)
        ) 
        //.catch();
     /*  .map(
        (r: Response) => {
          if (r.status === 200) {
            let objMenu2: Menu;
            if (r.json().status === 'OK') {
              objMenu2 = r.json().objeto as Menu;
              return objMenu2;
            } else {
              throw new UCuencaError('ERROR: ' + r.json().message);
            }
          } else {
            throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
          }
        }) */
      
  }


  editar(objMenu: Menu): Observable<Menu> {

    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/actualizar';


    return this._httpCustom
      .put(url,
        JSON.stringify(objMenu),
        { headers: Constantes.HEADERS })
        .pipe(map(
        (r: Response) => {
          if (r.status === 200) {
            let objMenu2: Menu;

            if (r.json().status === 'OK') {
              objMenu2 = r.json().objeto as Menu;
              return objMenu2;
            } else {
              throw new UCuencaError('ERROR: ' + r.json().message);
            }
          } else {
            console.error('llega error  actualizar');
            throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
          }
        }),
        catchError(this.errorHandler.handleError))
      //.catch(this.errorHandler.handleError);
  }


  /**
   * 
   * @param nombreAplicativo 
   */
  listarPorNombreAplicativo(nombreAplicativo: string): Observable<Menu[]> {
    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/listar/' + nombreAplicativo;

    console.log('entra a listarPorNombreAplicativo ' + url);

    return this._httpCustom.get(url).pipe(map((r: Response) => {
      console.log(' retorna respuesta ???');
      if (r.status === 200) {
        if (r.json().status === 'OK') {

          console.log(' retorna respuesta ok');

          let objConvenio: Menu = r.json().objeto as Menu;

          console.log('listarPorNombreAplicativo ' + JSON.stringify(r.json().objeto));

          return objConvenio;

        } else {
          throw new UCuencaError('ERROR: ' + r.json().message);
        }
      } else {
        throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
      }
    }),
    catchError(this.errorHandler.handleError))
     // .catch(this.errorHandler.handleError);
  }


  /**
   * Permite buscar los menus de un usuario
   * @param idAplicativo 
   * @param idUsuario 
   * @param idUnidad 
   */
  buscarMenusXUsuario(idAplicativo: string, idUsuario: number, idUnidad: number): Observable<Menu[]> {

    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/buscarMenusXUsuario/' + idAplicativo + '/' + idUsuario + '/' + idUnidad;
    console.log(url);


    return this._httpCustom.get(url).pipe(map((r: Response) => {
      if (r.status === 200) {
        if (r.json().status === 'OK') {

          let lstMenusArbol: Menu[] = r.json().objeto as Menu[];
          return lstMenusArbol;

        } else {
          throw new UCuencaError('ERROR: ' + r.json().message);
        }
      } else {
        throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
      }
    }),
    catchError(this.errorHandler.handleError))
      //.catch(this.errorHandler.handleError);
  }





  /**
   * Permite listar en una lista plana los menus
   * @param idRol 
   */
  listarPorIdRol(idRol: string): Observable<Menu[]> {

    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/listarPorIdRol/' + idRol;

    return this._httpCustom.get(url).pipe(map((r: Response) => {
      if (r.status === 200) {
        if (r.json().status === 'OK') {

          let objConvenio: Menu = r.json().objeto as Menu;
          return objConvenio;

        } else {
          throw new UCuencaError('ERROR: ' + r.json().message);
        }
      } else {
        throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
      }
    }),
    catchError(this.errorHandler.handleError))
     // .catch(this.errorHandler.handleError);
  }

  /**
   * Permite listar los menus en arbol por los ids del rol
   * @param idRol 
   */
  listarArbolPorIdRol(idRol: string): Observable<Menu[]> {

    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/listarPorIdRol/' + idRol;

    return this._httpCustom.get(url).pipe(map((r: Response) => {
      if (r.status === 200) {
        if (r.json().status === 'OK') {

          let objConvenio: Menu = r.json().objeto as Menu;
          return objConvenio;

        } else {
          throw new UCuencaError('ERROR: ' + r.json().message);
        }
      } else {
        throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
      }
    }),
    catchError(this.errorHandler.handleError))
      //.catch(this.errorHandler.handleError);
  }



  /**
   * Este se utilizara para poder presentar los menus en angular
   * @param nombreAplicativo 
   */
  listarTodoMenusPorAplicativoMenuItem(nombreAplicativo: string): Promise<MenuItem> {

    // console.log('INGRESA A listarTodoMenusPorAplicativoMenuItem ');
    let promesa = new Promise((resolve, reject) => {

      let itemRetorna: MenuItem;
      this.listarPorNombreAplicativo(nombreAplicativo).subscribe((lista) => {

        let objMenuPrincipal: Menu = new Menu();
        objMenuPrincipal.nombre = 'MENU PRINCIPAL';

        // Encapsula en un menu principal
        for (let index = 0; index < lista.length; index++) {
          const menu = lista[index];
          objMenuPrincipal.hijos.push(menu);
        }

        //      let root: MenuItem, Ejemplo instancioar ;
        let root = <MenuItem>{

        };
        root.items = [];

        this.funCargarItemsPrime(root, objMenuPrincipal);

        itemRetorna = root;

        resolve(itemRetorna);

      });

    });
    return promesa;
  }
  

  /**
   * Transformar una lista de menus en arbol, en una lista de menus Item
   * @param lista 
   */
  trasnformaMenuAMenuItem(lista: Menu[]): Promise<MenuItem> {

    let promesa = new Promise((resolve, reject) => {

      let itemRetorna: MenuItem;

      let objMenuPrincipal: Menu = new Menu();
      objMenuPrincipal.nombre = 'MENU PRINCIPAL';

      // Encapsula en un menu principal
      for (let index = 0; index < lista.length; index++) {
        const menu = lista[index];
        objMenuPrincipal.hijos.push(menu);
      }

      //      let root: MenuItem, Ejemplo instancioar ;
      let root = <MenuItem>{

      };
      root.items = [];

      this.funCargarItemsPrime(root, objMenuPrincipal);

      itemRetorna = root;

      resolve(itemRetorna);

    });
    return promesa;


  }







  transformar(lstMenus: Menu[]) {

    let items: MenuItem[];
  }

  /**
   * Permite cargar en MenusPrime los menus grouper, de forma recursiva
   * @param nodoRaiz 
   * @param objMenu 
   */
  private funCargarItemsPrime(nodoRaiz: any, objMenu: Menu): MenuItem {

    let lstMenusHijos: Menu[] = objMenu.hijos;
    if (lstMenusHijos != null && lstMenusHijos.length > 0) {
      for (let index = 0; index < lstMenusHijos.length; index++) {
        const objMenuHijo = lstMenusHijos[index];

        if (objMenuHijo.hijos != null && objMenuHijo.hijos.length > 0) {
          let nodoHijo = <MenuItem>{};
          nodoHijo.label = objMenuHijo.nombre;

          nodoHijo.url = objMenuHijo.ruta;
          if (objMenuHijo.nodoHoja) {
            nodoHijo.routerLink = objMenuHijo.ruta;
            nodoHijo.items  = null;
          }else{ 
            /**
             * indica que no agrege flecha para abajo
             */
            nodoHijo.items = [];
          }
         
          if (!objMenuHijo.icono || objMenuHijo.icono == '' ) {
            if (objMenuHijo.nodoHoja) {
              nodoHijo.icon = 'dashboard';
            } else {
              nodoHijo.icon = 'subject';
            }
            // console.log('sale a mostrar menu icono1 --------------> ' + nodoHijo.icon);
          } else {
            nodoHijo.icon = objMenuHijo.icono;

             //  TEMPORAL NO CARG BIEN IMAGNES
             if (objMenuHijo.nodoHoja) {
              nodoHijo.icon = 'dashboard';
            } else {
              nodoHijo.icon = 'subject';
            }

          }

          nodoHijo.items = [];


          let nodoLlega = this.funCargarItemsPrime(nodoHijo, objMenuHijo);
          nodoRaiz.items.push(nodoLlega);
        } else { // no tiene hijos

          /**
           * NO TIENE HIJOS objMenuHijo
           */

           // console.log('Carga menu si hijos ' + JSON.stringify(objMenuHijo));
           

          let nodoHijo = <MenuItem>{};
          nodoHijo.items = [];
          nodoHijo.label = objMenuHijo.nombre;

          nodoHijo.url = objMenuHijo.ruta;
          if (objMenuHijo.nodoHoja) {
            nodoHijo.routerLink = objMenuHijo.ruta;
            nodoHijo.items  = null;
          }else{ 
            /**
             * indica que no agrege flecha para abajo
             */
            nodoHijo.items = null;
          }
          //nodoHijo.icon = objMenuHijo.icono;
          
          if (!objMenuHijo.icono || objMenuHijo.icono == '' ) {
            if (objMenuHijo.nodoHoja) {
              nodoHijo.icon = 'dashboard';
            } else {
              nodoHijo.icon = 'subject';
            }
            
          } else {
            nodoHijo.icon = objMenuHijo.icono;

            //  TEMPORAL NO CARG BIEN IMAGNES
            if (objMenuHijo.nodoHoja) {
              nodoHijo.icon = 'dashboard';
            } else {
              nodoHijo.icon = 'subject';
            }

          }

          //console.log('sale a mostrar menu icono2 --------------> ' + nodoHijo.icon);



          nodoRaiz.items.push(nodoHijo);
        }
      }
    }

    // console.log('           retorna la llamada de ' + objMenu.nombre + ' -> ' + JSON.stringify(nodoRaiz));
    return nodoRaiz;
  }



  // ===================================
  // =============== NODOS =============
  // ===================================

  /**
   * Retorna los menus en formato nodo
   * @param nombreAplicativo 
   */
  listarTodoMenusPorAplicativoMenuTreeNode(nombreAplicativo: string, filtroRequiereUnidad: boolean): Promise<TreeNode> {

    console.log('INGRESA listarTodoMenusPorAplicativoMenuTreeNode');
    let promesa = new Promise((resolve, reject) => {


      console.log('INGRESA promesa');

      let itemRetorna: TreeNode;
      this.listarPorNombreAplicativo(nombreAplicativo).subscribe((lista) => {

        if (lista) {

          let objMenuPrincipal: Menu = new Menu();
          objMenuPrincipal.nombre = 'MENU PRINCIPAL';
          // Encapsula en un menu principal
          for (let index = 0; index < lista.length; index++) {
            const menu = lista[index];
            objMenuPrincipal.hijos.push(menu);
          }

          let root = <TreeNode>{
          };
          root.children = [];

          this.funCargarNodossPrime(root, objMenuPrincipal, filtroRequiereUnidad);

          itemRetorna = root;

          resolve(itemRetorna);
        }


      }, error => {
        reject(error);

      });

    });
    return promesa;
  }



  /**
   * Permite listar los nodos menus, buscando por el id del rol
   * @param idRol 
   */
  listarNodosMenusPorIdRol(idRol: string): Promise<TreeNode> {

    console.log('INGRESA listarNodosMenusPorIdRol');
    let promesa = new Promise((resolve, reject) => {


      let itemRetorna: TreeNode;
      this.listarArbolPorIdRol(idRol).subscribe((lista) => {

        if (lista) {

          let objMenuPrincipal: Menu = new Menu();
          objMenuPrincipal.nombre = 'MENU PRINCIPAL';
          // Encapsula en un menu principal
          for (let index = 0; index < lista.length; index++) {
            const menu = lista[index];
            objMenuPrincipal.hijos.push(menu);
          }
          let root = <TreeNode>{
          };
          root.children = [];

          this.funCargarNodossPrime(root, objMenuPrincipal, null);

          itemRetorna = root;
          resolve(itemRetorna);
        }

      }, error => {
        reject(error);

      });

    });
    return promesa;
  }



  /**
   * Permite cargar los nodos de forma recursiva
   * @param nodoRaiz 
   * @param objMenu 
   */
  private funCargarNodossPrime(nodoRaiz: any, objMenu: Menu, filtroRequiereUnidad: boolean): TreeNode {

    let lstMenusHijos: Menu[] = objMenu.hijos;
    if (lstMenusHijos != null && lstMenusHijos.length > 0) {
      for (let index = 0; index < lstMenusHijos.length; index++) {
        const objMenuHijo = lstMenusHijos[index];

        if (objMenuHijo.hijos != null && objMenuHijo.hijos.length > 0) {
          let nodoHijo = <TreeNode>{};
          nodoHijo.label = objMenuHijo.nombre;


          let datos = Menu.clonar(objMenuHijo);
          datos.hijos = null;
          nodoHijo.data = datos;

          nodoHijo.expanded = true;
          nodoHijo.children = [];
          let nodoLlega = this.funCargarNodossPrime(nodoHijo, objMenuHijo, filtroRequiereUnidad);
          nodoRaiz.children.push(nodoLlega);
        } else {
          let nodoHijo = <TreeNode>{};
          nodoHijo.children = [];
          nodoHijo.label = objMenuHijo.nombre;
          nodoHijo.expanded = true;
          nodoHijo.data = objMenuHijo;
          if (filtroRequiereUnidad != null) {
            if (filtroRequiereUnidad == true) {
              if (objMenuHijo.requiereUnidad == true) {
                nodoRaiz.children.push(nodoHijo);

              }
            } else {
              if (objMenuHijo.requiereUnidad == false) {
                nodoRaiz.children.push(nodoHijo);
              }

            }
          } else {//no controlar
            nodoRaiz.children.push(nodoHijo);
          }
        }
      }
    }
    return nodoRaiz;
  }






  /**
   * Trasnforma una lista plana de menus en una lista plana de Nodos, 
   * este es utilizado cuando se quiere dejar marcado un arbol
   * @param lstPlanaMenus 
   */
  transformaarMenusEnNodos(lstPlanaMenus: Menu[]): Promise<TreeNode[]> {

    return new Promise((resolve, reject) => {

      let respuesta: TreeNode[] = [];

      if (lstPlanaMenus) {
        // Encapsula en un menu principal
        for (let index = 0; index < lstPlanaMenus.length; index++) {
          const objMenu = lstPlanaMenus[index];
          let nuevoNodo = <TreeNode>{};
          nuevoNodo.children = [];
          nuevoNodo.label = objMenu.nombre;
          nuevoNodo.expanded = true;
          nuevoNodo.data = objMenu;
          respuesta.push(nuevoNodo);
        }
        resolve(respuesta);
      }


    });
    // return promesa;

  }




  /**
 * Consulta los menus de una persona en un aplicativo segun sus roles
 * @param idAplicativo 
 * @param idUsuario 
 * @param idUnidad 
 */
  consultaMenusPorAplicativoPorUsuarioPorUnidad(idAplicativo: string, idUsuario: number, idUnidad: number): Promise<TreeNode> {

    console.log('INGRESA listarTodoMenusPorAplicativoMenuTreeNode');
    let promesa = new Promise((resolve, reject) => {


      console.log('INGRESA promesa');

      let itemRetorna: TreeNode;
      this.buscarMenusXUsuario(idAplicativo, idUsuario, idUnidad).subscribe((lista) => {

        if (lista) {
          this.trasnformaMenuAMenuItem(lista).then(resp => {
            itemRetorna = resp;

            resolve(itemRetorna);
          }).catch(erro => {
            console.error('Error en tranforma menu a menu item ' + erro);
            resolve(null);
          });
        }

      }, error => {
        reject(error);

      });

    });
    return promesa;
  }

  public limpiar() {

  }



}

